import { useMemo } from 'react'

import { getPkField } from '@helpers'
import { ObjectFieldDTO } from '@types'

export const usePkField = (fields?: ObjectFieldDTO[]) => {
  return useMemo(() => getPkField(fields), [fields])
}
